import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

export function provideUIConfig(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAnimations(),
        provideToastr(), // registers Toastr services globally
        DatePipe,
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: false // Solves dark mode issues (because there is no dark mode in the theme)
                }
            }
        }),
        {
            provide: OVERLAY_DEFAULT_CONFIG,
            useValue: {
                usePopover: false
            }
        },
    ]);
}